import { SelectionDropdown } from "@libs/zapi-ui/custom";

type TGenerationTypeSelectProps = {
  generationType: string;
  setGenerationType: (generationType: string) => void;
};

const GENERATION_TYPE_OPTIONS = [
  { label: "All Types", value: "" },
  { label: "Chapter Generation", value: "chapter" },
  { label: "Project Prefill", value: "projectPrefill" },
  { label: "Executive Summary", value: "executiveSummary" },
  { label: "Claims", value: "claims" }
];

export function GenerationTypeSelect({ generationType, setGenerationType }: TGenerationTypeSelectProps) {
  return (
    <div className="space-y-2 w-[258px]">
      <SelectionDropdown
        placeholder="Select Generation Type"
        options={GENERATION_TYPE_OPTIONS}
        value={generationType}
        onChange={(v) => {
          setGenerationType(v);
        }}
        className="rounded-[8px]"
      />
    </div>
  );
}
